
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/after",
      function () {
        return require("private-next-pages/after.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/after"])
      });
    }
  